export class Capability {
  constructor(definition) {
    this.definition = definition;
  }
  toString() {
    return this.definition.name;
  }
  getName() {
    return this.definition.name;
  }
}